import { Plus } from '@creditornot/cb-icons';
import { Spinner, colors, cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
  uploading: boolean;
  disabled?: boolean;
};

const Root = styled.div<{ disabled: boolean }>`
  width: 56px;
  height: 56px;
  border-radius: 8px;
  background-color: ${cssThemedValue('surfaceMain')};
  border-width: 2px;
  border-style: dashed;
  border-color: ${({ disabled }) => (disabled ? cssThemedValue('borderPrimary') : colors.wolt100)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
`;

const StyledPlusIcon = styled(Plus).attrs({ height: 20 })<{ disabled: boolean }>`
  fill: ${({ disabled }) => (disabled ? cssThemedValue('borderPrimary') : colors.wolt100)};
`;

const ImageHoverThumbnail = ({ className, uploading, disabled = false }: Props) => {
  return (
    <Root className={className} disabled={disabled}>
      {disabled === false && uploading === true && <Spinner size="small" />}
      {uploading === false && <StyledPlusIcon disabled={disabled} />}
    </Root>
  );
};

export default React.memo(ImageHoverThumbnail);
